import { motion } from "framer-motion";
import { UserRound, Building2, ShieldCheck, Mic, ArrowUpRight } from "lucide-react";
import { PILLARS, IMAGES } from "../data";
import { useBooking } from "../BookingContext";

const ICONS = { UserRound, Building2, ShieldCheck, Mic };

export default function Pillars() {
  const { openBooking } = useBooking();

  return (
    <section id="pillars" data-testid="pillars-section" className="relative py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#070E1F]">
      <div className="max-w-3xl mb-14">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-12 bg-[#D4AF37]" />
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#D4AF37]">Pillars of Training</span>
        </div>
        <h2 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]">
          Built for <span className="gold-text">Individuals</span> &amp; <span className="gold-text">Corporations</span>
        </h2>
        <p className="mt-5 text-lg text-[#A3A8B8]">
          Whether you're advancing your own career or protecting an entire workforce, every program is
          delivered in-person or virtually with certification included.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-px bg-[#1D2847] border border-[#1D2847]">
        {PILLARS.map((p, i) => {
          const Icon = ICONS[p.icon];
          const featured = i === 2;
          return (
            <motion.button
              key={p.key}
              onClick={() => openBooking(p.interest)}
              data-testid={`pillar-${p.key}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`group relative text-left p-8 md:p-12 transition-colors overflow-hidden ${
                featured ? "bg-[#0C142A]" : "bg-[#050A15]"
              } hover:bg-[#101B36]`}
            >
              {featured && (
                <img src={IMAGES.osha} alt="" className="absolute inset-0 w-full h-full object-cover opacity-10 group-hover:opacity-20 transition-opacity" />
              )}
              <div className="relative z-10">
                <div className="inline-flex p-4 border border-[#D4AF37]/40 text-[#D4AF37] mb-6 group-hover:bg-[#D4AF37] group-hover:text-[#050A15] transition-colors">
                  <Icon size={28} />
                </div>
                <h3 className="font-display text-2xl font-bold tracking-tight mb-3 flex items-center gap-2">
                  {p.title}
                  <ArrowUpRight size={20} className="text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity" />
                </h3>
                <p className="text-[#A3A8B8] leading-relaxed max-w-md">{p.desc}</p>
              </div>
            </motion.button>
          );
        })}
      </div>
    </section>
  );
}
